import React, { useEffect, useRef } from 'react';
import Heading from '../../../generic-components/Heading';
import { ReactComponent as CheckIcon } from '../../../assets/svg/check.svg';
import { ReactComponent as ExitIcon } from '../../../assets/svg/exit.svg';
import Button from '../../../generic-components/Button';

interface IProps {
  title: string;
  autoCloseSec: number;
  onTimeElapsed: () => void;
}

export const HeaderNotification = ({ title, autoCloseSec, onTimeElapsed }: IProps) => {
  const loadTime = useRef(Date.now());

  useEffect(() => {
    const timerId = setInterval(() => {
      const timeDiff = Date.now() - loadTime.current;
      const elapsedTime = Math.round(timeDiff / 1000);
      if (elapsedTime >= autoCloseSec) {
        clearInterval(timerId);
        onTimeElapsed();
      }
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  }, []);

  return (
    <div
      className={`${title ? 'opacity-100' : 'opacity-0'} absolute z-50 left-[50%] bg-bw08 translate-x-[-50%] bottom-0 translate-y-[calc(100%+14px)] py-[10px] px-[14px] rounded-[6px] flex items-center justify-center gap-[10px] shadow-light fadeIn`}
    >
      <CheckIcon className='w-[20px] stroke-bw00' />
      <Heading id='headerNotificationContent' type='HTML' title={title} className='text-bw00' />
      <Button
        onClick={onTimeElapsed}
        className='cursor-pointer'
        id='closeUpperMessage'
        childElement={<ExitIcon className='w-[20px] stroke-bw00 fill-bw00 cursor-pointer' />}
      />
    </div>
  );
};
